var map = {
	"./logo_pl_de.svg": 76799,
	"./logo_pl_en.svg": 24379,
	"./logo_pl_fr.svg": 23590,
	"./logo_pl_invert_de.svg": 12460,
	"./logo_pl_invert_en.svg": 60256,
	"./logo_pl_invert_fr.svg": 20521,
	"./logo_pl_invert_nl.svg": 67543,
	"./logo_pl_nl.svg": 28328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74286;